import { render, staticRenderFns } from "./project-step-documents.vue?vue&type=template&id=1e2b5936&"
import script from "./project-step-documents.vue?vue&type=script&lang=js&"
export * from "./project-step-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports